var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChatbubbleCounter = function SvgChatbubbleCounter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.183 14.642a1.187 1.187 0 0 1 .196-.9 7.473 7.473 0 0 0 1.371-4.301c0-4.418-3.917-8-8.75-8-4.832 0-8.75 3.582-8.75 8s3.918 8 8.75 8c.811 0 1.596-.101 2.341-.289a.81.81 0 0 1 .624.089l4.512 2.701c.33.197.711-.136.63-.551l-.924-4.749z"
  })));
};
export default SvgChatbubbleCounter;